export default "__VITE_ASSET__CMSNN1e3__"